import { client } from './client';

const { VITE_AEM_URL } = import.meta.env;

export const getAemContent = (pageId, requestConfig = {}) => {
  return client(
    `serviceoutages/journeys/${pageId}/jcr:content.data.json`,
    {
      ...requestConfig,
      withCredentials: false,
      method: 'GET'
    },
    VITE_AEM_URL
  );
};
